import type { IconSvgObject } from './types';

const BetweenHorizontalStartIcon: IconSvgObject = [
  ["path", { d: "M20 3H10C8.89543 3 8 3.89543 8 5V8C8 9.10457 8.89543 10 10 10H20C21.1046 10 22 9.10457 22 8V5C22 3.89543 21.1046 3 20 3Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M20 14H10C8.89543 14 8 14.8954 8 16V19C8 20.1046 8.89543 21 10 21H20C21.1046 21 22 20.1046 22 19V16C22 14.8954 21.1046 14 20 14Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M2 9L5 12L2 15", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default BetweenHorizontalStartIcon;
